import {Template} from '@mintdata-wsp/common/state/DataState';
import {DesignsFilters, DesignsFilterType} from '@mintdata-wsp/wsp/ui/views/workspace/home/filters/DesignsFilters';
import {TemplatesListItem} from '@mintdata-wsp/wsp/ui/views/workspace/home/templates/TemplatesListItem';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./TemplatesList.less');
const cx = classnames.bind(styles);

interface Props
{
    templates:Template[];
    filterType?:DesignsFilterType;
    highlightSearchTerm?:boolean;
}

@observer
export class TemplatesList extends React.Component<Props, any>
{
    private _renderSpacers = ():JSX.Element[] =>
    {
        return [...Array.from(Array(10).keys())].map((index:number) =>
        {
            return (
                <div
                    key={'spacer' + index}
                    className={cx(styles.design, styles.spaceDesign)}
                />
            );
        });
    };

    private _renderDesignsList = ():JSX.Element[] =>
    {
        const {templates, highlightSearchTerm} = this.props;

        return templates.map((template:Template) =>
        {
            return (
                <TemplatesListItem
                    key={`${template.designId}${template.devDesignId}`}
                    template={template}
                    highlightSearchTerm={highlightSearchTerm}
                />
            );
        });
    };

    private _renderDesigns = ():JSX.Element[] =>
    {
        return [
            ...this._renderDesignsList(),
            ...this._renderSpacers(),
        ];
    };

    render():JSX.Element
    {
        const {templates, filterType} = this.props;

        const hasTemplates:boolean = templates && templates.length != 0;

        return (
            <div className={styles.designsWrapper}>

                <DesignsFilters filterType={filterType || DesignsFilterType.Templates} />

                <div className={cx(styles.designs)}>
                    {
                        hasTemplates &&
                        this._renderDesigns()
                    }
                </div>
            </div>
        );
    }
}
